import React, { useState } from 'react';
import { useQuery } from 'react-query';

import { fetchFromFirebase } from '../../hooks/fetchFromFirebase';

import FooterGemi from './footerGemi';

//images
import LocationPin from '../../assets/images/location_pin.png';
import ContactPin from '../../assets/images/contact_pin.png';
import WorkingHoursPin from '../../assets/images/working-hours.png';

const ContactInfo = ({ collection, id }) => {
    const [activeItem, setActiveItem] = useState(null);
    
    const { isLoading, isError, data, error } = useQuery(['Dealer Info', collection, id], () => fetchFromFirebase('dealerInfo', 'KD6FHhBRkM5ISPT8qTRZ'));
  
    if (isLoading) {
      return <div>Loading...</div>;
    }
  
    if (isError) {
      return <div>Error: {error.message}</div>;
    }
    
    const dealers = [
        { ekthesiName: data.dealerEkthesiName, address: data.dealerAddress, phone: data.dealerPhone, email: data.dealerEmail, monday: data.dealerMonday, tuesday: data.dealerTuesday, wednesday: data.dealerWednesday, thursday: data.dealerThursday, friday: data.dealerFriday, saturday: data.dealerSaturday},
        { ekthesiName: data.dealerEkthesiNameB, address: data.dealerAddressB, phone: data.dealerPhoneB, email: data.dealerEmailB, monday: data.dealerMondayB, tuesday: data.dealerTuesdayB, wednesday: data.dealerWednesdayB, thursday: data.dealerThursdayB, friday: data.dealerFridayB, saturday: data.dealerSaturdayB},
        { ekthesiName: data.dealerEkthesiNameC, address: data.dealerAddressC, phone: data.dealerPhoneC, email: data.dealerEmailC, monday: data.dealerMondayC, tuesday: data.dealerTuesdayC, wednesday: data.dealerWednesdayC, thursday: data.dealerThursdayC, friday: data.dealerFridayC, saturday: data.dealerSaturdayC},
        { ekthesiName: data.dealerEkthesiNameD, address: data.dealerAddressD, phone: data.dealerPhoneD, email: data.dealerEmailD, monday: data.dealerMondayD, tuesday: data.dealerTuesdayD, wednesday: data.dealerWednesdayD, thursday: data.dealerThursdayD, friday: data.dealerFridayD, saturday: data.dealerSaturdayD},
        { ekthesiName: data.dealerEkthesiNameE, address: data.dealerAddressE, phone: data.dealerPhoneE, email: data.dealerEmailE, monday: data.dealerMondayE, tuesday: data.dealerTuesdayE, wednesday: data.dealerWednesdayE, thursday: data.dealerThursdayE, friday: data.dealerFridayE, saturday: data.dealerSaturdayE},
    ];

    const handleItemClick = (index) => {
        if (activeItem === index) {
          // If the clicked item is already active, close it
          setActiveItem(null);
        } else {
          // Otherwise, set the clicked item as active
          setActiveItem(index);
        }
    };

  return (
    <section id="contact-section">
        <div className="row padding-vert-120 container">
            <h3 className="fw-900 ta-center">Επικοινωνία</h3>

            <div className='desktop'>
                <div className="flex-row padding-vert-40">
                    {dealers.map((dealer, index) => (
                    <div key={index} className='ta-center pointer' onClick={() => handleItemClick(index)}>
                        <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                        <label>{data.dealerName} -<br />{dealer.ekthesiName}</label>
                    </div>
                    ))}
                </div>

                {activeItem !== null && (
                    <div className="accordion-item padding-vert-40">
                        <div className="col s12 m4 ta-center">
                            <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                            <p>{dealers[activeItem].address}</p>
                            <p className='padding-vert-10'><a href={'https://www.google.gr/maps/search/' + dealers[activeItem].address} className="btn-blue btn-animation fs-14 ta-center" target="_blank">Βρείτε μας στο χάρτη</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={ContactPin} alt="Επικοινωνία" className="max-height-50"/>
                            <p className="blue fw-900">Επικοινωνήστε μαζί μας</p>
                            <p>Τηλ: {dealers[activeItem].phone}<br />Email: <a href={"mailto:" + dealers[activeItem].email} className="black">{dealers[activeItem].email}</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={WorkingHoursPin} alt="Ωράριο" className="max-height-50"/>
                            <p className="blue fw-900">Ώρες λειτουργίας</p>
                            <table className="footer-table">
                                <tbody>
                                    <tr>
                                        <td>Δευτέρα</td>
                                        <td>{dealers[activeItem].monday}</td>
                                    </tr>
                                    <tr>
                                        <td>Τρίτη</td>
                                        <td>{dealers[activeItem].tuesday}</td>
                                    </tr>
                                    <tr>
                                        <td>Τετάρτη</td>
                                        <td>{dealers[activeItem].wednesday}</td>
                                    </tr>
                                    <tr>
                                        <td>Πέμπτη</td>
                                        <td>{dealers[activeItem].thursday}</td>
                                    </tr>
                                    <tr>
                                        <td>Παρασκευή</td>
                                        <td>{dealers[activeItem].friday}</td>
                                    </tr>
                                    <tr>
                                        <td>Σάββατο</td>
                                        <td>{dealers[activeItem].saturday}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                        <div className="col s12 fs-11 ta-center margin-top-40">
                            ΣΗΜΕΙΩΣΗ: το ωράριο ενδέχεται να έχει μικρές διαφοροποιήσεις από κατάστημα σε κατάστημα και ανά τμήμα
                        </div>
                        </div>

                )}
            </div>


            <div className='mobile'>

                <div className="accordion-item padding-vert-40">
                    <input
                    type="checkbox"
                    id="item1"
                    checked={activeItem === 0}
                    onChange={() => handleItemClick(0)}
                    />
                    <label htmlFor="item1">{data.dealerName} - {data.dealerEkthesiName}</label>
                    {activeItem === 0 && (
                    <div className="content margin-top-20">
                        
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                            <p className="blue fw-900">Που θα μας βρείτε</p>
                            <p>{data.dealerAddress}</p>
                            <p className='padding-vert-10'><a href={'https://www.google.gr/maps/search/' + data.dealerAddress} className="btn-blue btn-animation fs-14 ta-center" target="_blank">Βρείτε μας στο χάρτη</a></p>
                        </div>
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={ContactPin} alt="Επικοινωνία" className="max-height-50"/>
                            <p className="blue fw-900">Επικοινωνήστε μαζί μας</p>
                            <p>Τηλ: {data.dealerPhone}<br />Email: <a href={"mailto:" + data.dealerEmail} className="black">{data.dealerEmail}</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={WorkingHoursPin} alt="Ωράριο" className="max-height-50"/>
                            <p className="blue fw-900">Ώρες λειτουργίας</p>
                            <table className="footer-table">
                                <tbody>
                                    <tr>
                                        <td>Δευτέρα</td>
                                        <td>{data.dealerMonday}</td>
                                    </tr>
                                    <tr>
                                        <td>Τρίτη</td>
                                        <td>{data.dealerTuesday}</td>
                                    </tr>
                                    <tr>
                                        <td>Τετάρτη</td>
                                        <td>{data.dealerWednesday}</td>
                                    </tr>
                                    <tr>
                                        <td>Πέμπτη</td>
                                        <td>{data.dealerThursday}</td>
                                    </tr>
                                    <tr>
                                        <td>Παρασκευή</td>
                                        <td>{data.dealerFriday}</td>
                                    </tr>
                                    <tr>
                                        <td>Σάββατο</td>
                                        <td>{data.dealerSaturday}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                        <div className="col s12 fs-11 ta-center margin-top-40">
                            ΣΗΜΕΙΩΣΗ: το ωράριο ενδέχεται να έχει μικρές διαφοροποιήσεις από κατάστημα σε κατάστημα και ανά τμήμα
                        </div>
                    </div>
                    )}
                </div>

                <div className="accordion-item padding-vert-40">
                    <input
                    type="checkbox"
                    id="item2"
                    checked={activeItem === 1}
                    onChange={() => handleItemClick(1)}
                    />
                    <label htmlFor="item2">{data.dealerName} - {data.dealerEkthesiNameB}</label>
                    {activeItem === 1 && (
                        <div className="content margin-top-20">
                            
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                            <p className="blue fw-900">Που θα μας βρείτε</p>
                            <p>{data.dealerAddressB}</p>
                            <p className='padding-vert-10'><a href={'https://www.google.gr/maps/search/' + data.dealerAddressB} className="btn-blue btn-animation fs-14 ta-center" target="_blank">Βρείτε μας στο χάρτη</a></p>
                        </div>
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={ContactPin} alt="Επικοινωνία" className="max-height-50"/>
                            <p className="blue fw-900">Επικοινωνήστε μαζί μας</p>
                            <p>Τηλ: {data.dealerPhoneB}<br />Email: <a href={"mailto:" + data.dealerEmailB} className="black">{data.dealerEmailB}</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={WorkingHoursPin} alt="Ωράριο" className="max-height-50"/>
                            <p className="blue fw-900">Ώρες λειτουργίας</p>
                            <table className="footer-table">
                                <tbody>
                                    <tr>
                                        <td>Δευτέρα</td>
                                        <td>{data.dealerMondayB}</td>
                                    </tr>
                                    <tr>
                                        <td>Τρίτη</td>
                                        <td>{data.dealerTuesdayB}</td>
                                    </tr>
                                    <tr>
                                        <td>Τετάρτη</td>
                                        <td>{data.dealerWednesdayB}</td>
                                    </tr>
                                    <tr>
                                        <td>Πέμπτη</td>
                                        <td>{data.dealerThursdayB}</td>
                                    </tr>
                                    <tr>
                                        <td>Παρασκευή</td>
                                        <td>{data.dealerFridayB}</td>
                                    </tr>
                                    <tr>
                                        <td>Σάββατο</td>
                                        <td>{data.dealerSaturdayB}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                        <div className="col s12 fs-11 ta-center margin-top-40">
                            ΣΗΜΕΙΩΣΗ: το ωράριο ενδέχεται να έχει μικρές διαφοροποιήσεις από κατάστημα σε κατάστημα και ανά τμήμα
                        </div>
                    </div>
                    )}
                </div>

                <div className="accordion-item padding-vert-40">
                    <input
                    type="checkbox"
                    id="item3"
                    checked={activeItem === 2}
                    onChange={() => handleItemClick(2)}
                    />
                    <label htmlFor="item3">{data.dealerName} - {data.dealerEkthesiNameC}</label>
                    {activeItem === 2 && (
                        <div className="content margin-top-20">
                            
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                            <p className="blue fw-900">Που θα μας βρείτε</p>
                            <p>{data.dealerAddressC}</p>
                            <p className='padding-vert-10'><a href={'https://www.google.gr/maps/search/' + data.dealerAddressC} className="btn-blue btn-animation fs-14 ta-center" target="_blank">Βρείτε μας στο χάρτη</a></p>
                        </div>
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={ContactPin} alt="Επικοινωνία" className="max-height-50"/>
                            <p className="blue fw-900">Επικοινωνήστε μαζί μας</p>
                            <p>Τηλ: {data.dealerPhoneC}<br />Email: <a href={"mailto:" + data.dealerEmailC} className="black">{data.dealerEmailC}</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={WorkingHoursPin} alt="Ωράριο" className="max-height-50"/>
                            <p className="blue fw-900">Ώρες λειτουργίας</p>
                            <table className="footer-table">
                                <tbody>
                                    <tr>
                                        <td>Δευτέρα</td>
                                        <td>{data.dealerMondayC}</td>
                                    </tr>
                                    <tr>
                                        <td>Τρίτη</td>
                                        <td>{data.dealerTuesdayC}</td>
                                    </tr>
                                    <tr>
                                        <td>Τετάρτη</td>
                                        <td>{data.dealerWednesdayC}</td>
                                    </tr>
                                    <tr>
                                        <td>Πέμπτη</td>
                                        <td>{data.dealerThursdayC}</td>
                                    </tr>
                                    <tr>
                                        <td>Παρασκευή</td>
                                        <td>{data.dealerFridayC}</td>
                                    </tr>
                                    <tr>
                                        <td>Σάββατο</td>
                                        <td>{data.dealerSaturdayC}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                        <div className="col s12 fs-11 ta-center margin-top-40">
                            ΣΗΜΕΙΩΣΗ: το ωράριο ενδέχεται να έχει μικρές διαφοροποιήσεις από κατάστημα σε κατάστημα και ανά τμήμα
                        </div>
                    </div>
                    )}
                </div>

                <div className="accordion-item padding-vert-40">
                    <input
                    type="checkbox"
                    id="item4"
                    checked={activeItem === 3}
                    onChange={() => handleItemClick(3)}
                    />
                    <label htmlFor="item4">{data.dealerName} - {data.dealerEkthesiNameD}</label>
                    {activeItem === 3 && (
                        <div className="content margin-top-20">
                            
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                            <p className="blue fw-900">Που θα μας βρείτε</p>
                            <p>{data.dealerAddressD}</p>
                            <p className='padding-vert-10'><a href={'https://www.google.gr/maps/search/' + data.dealerAddressD} className="btn-blue btn-animation fs-14 ta-center" target="_blank">Βρείτε μας στο χάρτη</a></p>
                        </div>
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={ContactPin} alt="Επικοινωνία" className="max-height-50"/>
                            <p className="blue fw-900">Επικοινωνήστε μαζί μας</p>
                            <p>Τηλ: {data.dealerPhoneD}<br />Email: <a href={"mailto:" + data.dealerEmailD} className="black">{data.dealerEmailD}</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={WorkingHoursPin} alt="Ωράριο" className="max-height-50"/>
                            <p className="blue fw-900">Ώρες λειτουργίας</p>
                            <table className="footer-table">
                                <tbody>
                                    <tr>
                                        <td>Δευτέρα</td>
                                        <td>{data.dealerMondayD}</td>
                                    </tr>
                                    <tr>
                                        <td>Τρίτη</td>
                                        <td>{data.dealerTuesdayD}</td>
                                    </tr>
                                    <tr>
                                        <td>Τετάρτη</td>
                                        <td>{data.dealerWednesdayD}</td>
                                    </tr>
                                    <tr>
                                        <td>Πέμπτη</td>
                                        <td>{data.dealerThursdayD}</td>
                                    </tr>
                                    <tr>
                                        <td>Παρασκευή</td>
                                        <td>{data.dealerFridayD}</td>
                                    </tr>
                                    <tr>
                                        <td>Σάββατο</td>
                                        <td>{data.dealerSaturdayD}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                        <div className="col s12 fs-11 ta-center margin-top-40">
                            ΣΗΜΕΙΩΣΗ: το ωράριο ενδέχεται να έχει μικρές διαφοροποιήσεις από κατάστημα σε κατάστημα και ανά τμήμα
                        </div>
                    </div>
                    )}
                </div>

                <div className="accordion-item padding-vert-40">
                    <input
                    type="checkbox"
                    id="item5"
                    checked={activeItem === 4}
                    onChange={() => handleItemClick(4)}
                    />
                    <label htmlFor="item5">{data.dealerName} - {data.dealerEkthesiNameE}</label>
                    {activeItem === 4 && (
                        <div className="content margin-top-20">
                            
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={LocationPin} alt="Τοποθεσία" className="max-height-50"/>
                            <p className="blue fw-900">Που θα μας βρείτε</p>
                            <p>{data.dealerAddressE}</p>
                            <p className='padding-vert-10'><a href={'https://www.google.gr/maps/search/' + data.dealerAddressE} className="btn-blue btn-animation fs-14 ta-center" target="_blank">Βρείτε μας στο χάρτη</a></p>
                        </div>
                        <div className="col s12 m4 ta-center margin-bottom-40">
                            <img src={ContactPin} alt="Επικοινωνία" className="max-height-50"/>
                            <p className="blue fw-900">Επικοινωνήστε μαζί μας</p>
                            <p>Τηλ: {data.dealerPhoneE}<br />Email: <a href={"mailto:" + data.dealerEmailE} className="black">{data.dealerEmailE}</a></p>
                        </div>
                        <div className="col s12 m4 ta-center">
                            <img src={WorkingHoursPin} alt="Ωράριο" className="max-height-50"/>
                            <p className="blue fw-900">Ώρες λειτουργίας</p>
                            <table className="footer-table">
                                <tbody>
                                    <tr>
                                        <td>Δευτέρα</td>
                                        <td>{data.dealerMondayE}</td>
                                    </tr>
                                    <tr>
                                        <td>Τρίτη</td>
                                        <td>{data.dealerTuesdayE}</td>
                                    </tr>
                                    <tr>
                                        <td>Τετάρτη</td>
                                        <td>{data.dealerWednesdayE}</td>
                                    </tr>
                                    <tr>
                                        <td>Πέμπτη</td>
                                        <td>{data.dealerThursdayE}</td>
                                    </tr>
                                    <tr>
                                        <td>Παρασκευή</td>
                                        <td>{data.dealerFridayE}</td>
                                    </tr>
                                    <tr>
                                        <td>Σάββατο</td>
                                        <td>{data.dealerSaturdayE}</td>
                                    </tr>
                                </tbody>
                            </table> 
                        </div>
                        <div className="col s12 fs-11 ta-center margin-top-40">
                            ΣΗΜΕΙΩΣΗ: το ωράριο ενδέχεται να έχει μικρές διαφοροποιήσεις από κατάστημα σε κατάστημα και ανά τμήμα
                        </div>
                    </div>
                    )}
                </div>
            </div>
            <FooterGemi />
        </div>
        
    </section>
  );
};

export default ContactInfo;
